import client from "services/api-client";

interface Clinic {
  id: number;
  name: string;
  flags: Flag[];
  timezone: string;
}

interface Flag {
  id: number;
  name: string;
  slug: string;
}

export interface LinkedUser {
  id: string | number;
  name: string;
  targetUserId: number;
}

interface Organization {
  id: number;
  name: string;
  referralPartnerCode?: string;
}

interface MroReviewQuota {
  quarter: string;
  reviewYear: string;
  periodReviewQuotaCount: number;
  periodReviewQuotaPercent: number;
  reviewCountPeriodToDate: number;
  reviewCompletedCountPeriodToDate: number;
}

export interface CurrentUser {
  mroReviewQuota?: MroReviewQuota;
  currentClinic?: Clinic;
  email: string;
  firstName: string;
  fullName: string;
  id: number;
  lastName: string;
  linkedUsersToTarget: LinkedUser[];
  middleName: string | null;
  roles: string[];
  name?: string;
  organizations: Organization[];
}

interface CurrentUserResponse {
  currentUser: CurrentUser;
  meta: {
    inProgressPatientMedicalHistory: number | null;
  };
}

const BASE_URL = "/api/priv/v1/me";

export function getCurrentUser(): Promise<CurrentUserResponse> {
  return client.get(BASE_URL).then(({ data }) => data);
}

export interface UpdateCurrentUserParams {
  currentClinicId: number;
}

export function updateCurrentUser(
  params: Partial<UpdateCurrentUserParams>
): Promise<CurrentUserResponse> {
  return client.put(BASE_URL, params).then(({ data }) => data);
}
